import React from "react";
import { DocumentCommentsTable, DocumentsTable } from "../../Elements";

export const DocumentsTab = React.memo(() => {
  return (
    <>
      <DocumentsTable />
      <DocumentCommentsTable />
    </>
  );
});
